import React, { useEffect, useState } from "react";
import AvoirHeader from "../Components/Avoir/AvoirHeader";
import AvoirDetails from "../Components/Avoir/AvoirDetails";
import AvoirForm from "../Components/Avoir/AvoirForm";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentAvoirs } from "../REDUX/actions/avoir";
import { useLocation, useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const CurrentAvoirsView = () => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const location = useLocation();
  const { currentAvoirs, loading } = useSelector((state) => state.avoirReducer);
  const [selectedAvoir, setSelectedAvoir] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getCurrentAvoirs(() => navigate("/commandes")));
  }, [dispatch, navigate]);

  useEffect(() => {
    if (currentAvoirs?.length > 0) {
      setSelectedAvoir(
        currentAvoirs?.find((avoir) => avoir.id === location?.state?.id) ??
          currentAvoirs[0]
      );
    }
  }, [currentAvoirs, location]);

  return (
    <div className="position-relative">
      {loading && (
        <div className="position-absolute top-0 start-0 w-100 h-100 bg-white bg-opacity-50 z-9999 d-flex align-items-center justify-content-center">
          <Spinner />
        </div>
      )}
      {currentAvoirs?.length > 0 ? (
        <>
          <AvoirHeader
            list={currentAvoirs}
            select={setSelectedAvoir}
            selected={selectedAvoir}
          />
          <AvoirDetails data={selectedAvoir} />
          <AvoirForm data={selectedAvoir} />
        </>
      ) : (
        <span className="py-3 px-4 text-center f14 text-lightBlack">
          {t("No results found")}
        </span>
      )}
    </div>
  );
};

export default CurrentAvoirsView;
